var map = {
	"./bg-BG.json": 1366,
	"./ca-ES.json": 1367,
	"./cs-CZ.json": 1368,
	"./de-DE.json": 1369,
	"./el-GR.json": 1370,
	"./en-US.json": 797,
	"./es-ES.json": 1371,
	"./et-EE.json": 1372,
	"./fi-FI.json": 1373,
	"./fr-FR.json": 1374,
	"./he-IL.json": 1375,
	"./it-IT.json": 1376,
	"./ja-JP.json": 1377,
	"./ko-KR.json": 1378,
	"./nb-NO.json": 1379,
	"./nn-NO.json": 1380,
	"./pl-PL.json": 1381,
	"./pt-BR.json": 1382,
	"./ro-RO.json": 1383,
	"./ru-RU.json": 1384,
	"./sv-SE.json": 1385,
	"./tr-TR.json": 1386,
	"./zh-CN.json": 1387
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1365;